/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Cancellation_Period_HintInputs */

const en_admin_resources_cancellation_period_hint = /** @type {(inputs: Admin_Resources_Cancellation_Period_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hours before start that cancellation is allowed`)
};

const de_admin_resources_cancellation_period_hint = /** @type {(inputs: Admin_Resources_Cancellation_Period_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Stunden vor Beginn der Buchung eine Stornierung möglich ist`)
};

const es_admin_resources_cancellation_period_hint = /** @type {(inputs: Admin_Resources_Cancellation_Period_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas antes del inicio que se permite la cancelación`)
};

const fr_admin_resources_cancellation_period_hint = /** @type {(inputs: Admin_Resources_Cancellation_Period_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heures avant le début pendant lesquelles l'annulation est autorisée`)
};

const nl_admin_resources_cancellation_period_hint = /** @type {(inputs: Admin_Resources_Cancellation_Period_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uren vóór de start waarin annulering is toegestaan`)
};

/** @type {(inputs: Admin_Resources_Cancellation_Period_HintInputs) => LocalizedString} */
const it_admin_resources_cancellation_period_hint = en_admin_resources_cancellation_period_hint;

/** @type {(inputs: Admin_Resources_Cancellation_Period_HintInputs) => LocalizedString} */
const pt_br2_admin_resources_cancellation_period_hint = en_admin_resources_cancellation_period_hint;

/** @type {(inputs: Admin_Resources_Cancellation_Period_HintInputs) => LocalizedString} */
const pl_admin_resources_cancellation_period_hint = en_admin_resources_cancellation_period_hint;

/** @type {(inputs: Admin_Resources_Cancellation_Period_HintInputs) => LocalizedString} */
const hu_admin_resources_cancellation_period_hint = en_admin_resources_cancellation_period_hint;

/** @type {(inputs: Admin_Resources_Cancellation_Period_HintInputs) => LocalizedString} */
const ro_admin_resources_cancellation_period_hint = en_admin_resources_cancellation_period_hint;

/**
* | output |
* | --- |
* | "Hours before start that cancellation is allowed" |
*
* @param {Admin_Resources_Cancellation_Period_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_cancellation_period_hint = /** @type {((inputs?: Admin_Resources_Cancellation_Period_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Cancellation_Period_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_cancellation_period_hint(inputs)
	if (locale === "de") return de_admin_resources_cancellation_period_hint(inputs)
	if (locale === "es") return es_admin_resources_cancellation_period_hint(inputs)
	if (locale === "fr") return fr_admin_resources_cancellation_period_hint(inputs)
	if (locale === "nl") return nl_admin_resources_cancellation_period_hint(inputs)
	if (locale === "it") return it_admin_resources_cancellation_period_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_cancellation_period_hint(inputs)
	if (locale === "pl") return pl_admin_resources_cancellation_period_hint(inputs)
	if (locale === "hu") return hu_admin_resources_cancellation_period_hint(inputs)
	return ro_admin_resources_cancellation_period_hint(inputs)
});
export { admin_resources_cancellation_period_hint as "admin.resources.cancellation_period_hint" }